import { jsx as s } from "@emotion/react/jsx-runtime";
import i, { textFieldClasses as r } from "@mui/material/TextField";
import { forwardRef as l } from "react";
const m = r, o = l((e, t) => /* @__PURE__ */ s(i, { ...e, inputRef: t }));
o.displayName = "TextField";
export {
  o as T,
  m as t
};
